export abstract class ApplicationVersion {
  version: string;
}

